import React from 'react';
import { FileText } from 'lucide-react';

import { Button } from './ui/button';

const PlanSection = ({ content, architecture }) => {
  if (!content) return null;
  const plan = content;

  return (
    <section id="plan" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {plan.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-amber-500 mx-auto rounded-full" />
          <p className="mt-6 text-lg text-slate-600 max-w-2xl mx-auto">
            {plan.description}
          </p>
        </div>

        {/* Floor Plan Placeholder */}
        <div className="max-w-4xl mx-auto">
          {plan.floorPlanImage ? (
            // Display uploaded floor plan image
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={plan.floorPlanImage} 
                alt="Floor Plans"
                className="w-full h-auto object-contain bg-white"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8 text-center">
                <h3 className="text-2xl font-bold text-white mb-2">
                  Detailed Floor Plans
                </h3>
                <p className="text-white/90 mb-4">
                  {plan.note}
                </p>
                <Button
                  size="lg"
                  className="bg-blue-600 hover:bg-blue-700"
                  onClick={() => {
                    document.getElementById('contact').scrollIntoView({
                      behavior: 'smooth'
                    });
                  }}
                >
                  Request More Information
                </Button>
              </div>
            </div>
          ) : (
            // Placeholder when no image uploaded
            <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl p-12 border-2 border-dashed border-slate-300 text-center">
              <FileText className="w-16 h-16 text-slate-400 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-slate-900 mb-2">
                Detailed Floor Plans Available
              </h3>
              <p className="text-slate-600 mb-8 max-w-xl mx-auto">
                {plan.note}
              </p>
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700"
                onClick={() => {
                  document.getElementById('contact').scrollIntoView({
                    behavior: 'smooth'
                  });
                }}
              >
                Request Floor Plans
              </Button>
            </div>
          )}
        </div>

        {/* Property Summary Grid */}
        <div className="grid md:grid-cols-2 gap-8 mt-16">
          {architecture.properties.map((property) => (
            <div
              key={property.id}
              className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 hover:shadow-xl transition-shadow duration-300"
            >
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {property.name}
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center py-2 border-b border-slate-200">
                  <span className="text-slate-600">Total Area</span>
                  <span className="font-semibold text-slate-900">
                    {property.specs.area}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-slate-200">
                  <span className="text-slate-600">Bedrooms</span>
                  <span className="font-semibold text-slate-900">
                    {property.specs.bedrooms}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-slate-200">
                  <span className="text-slate-600">Bathrooms</span>
                  <span className="font-semibold text-slate-900">
                    {property.specs.bathrooms}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="text-slate-600">Guest Capacity</span>
                  <span className="font-semibold text-slate-900">
                    {property.specs.capacity}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlanSection;
